import React from 'react';
import { useTranslation } from 'react-i18next';
import MealSearchImage from '../../../assets/images/png/search-meal-icon.png';

export const MealSearchLoading: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="meal-search-loading">
      <img src={MealSearchImage} alt="Meal Search" />
      <span>{t('Searching Offers around')}...</span>
    </div>
  );
};
